export const fieldErrorValue = (fieldErrors, fieldName) => {
    if (!fieldErrors || fieldErrors.length === 0) {
        return null;
    }
    const fieldError = fieldErrors.find(error => error.field === fieldName);
    return fieldError && fieldError.error;
};